import React from 'react';
import './style.scss';

export function Form(props) {
  const { className, ...restProps } = props;

  return <form className={'custom-form ' + (className ?? '')} {...restProps} />;
}
